var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelRedditFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.15 12a1.21 1.21 0 0 0-2.07-.855c-.855-.585-1.98-.945-3.24-.99l.63-2.835 1.98.45c0 .585.495 1.08 1.08 1.08s1.08-.495 1.08-1.08-.495-1.08-1.08-1.08a1.05 1.05 0 0 0-.945.585L13.38 6.78c-.135-.045-.27.045-.315.18l-.72 3.195c-1.305.045-2.43.405-3.33.99a1.21 1.21 0 0 0-2.07.855c0 .495.27.9.675 1.08-.045.18-.045.36-.045.54 0 1.845 2.205 3.33 4.95 3.33s4.95-1.485 4.95-3.33c0-.18 0-.36-.045-.54.405-.18.675-.585.675-1.08Zm-9.6 1.215c0-.585.495-1.08 1.08-1.08s1.08.495 1.08 1.08-.495 1.08-1.08 1.08-1.08-.495-1.08-1.08m5.52 2.52c-.675.675-1.755.72-2.52.72s-1.845-.045-2.52-.72c-.135-.135-.135-.315 0-.45s.315-.135.45 0c.495.495 1.35.63 2.07.63s1.575-.135 2.07-.63c.135-.135.315-.135.45 0s.135.315 0 .45m-.21-1.44c-.585 0-1.08-.495-1.08-1.08s.495-1.08 1.08-1.08 1.08.495 1.08 1.08-.495 1.08-1.08 1.08"
}))));
export default SvgGemChannelRedditFilled;